(function () {
  'use strict';

  angular.module('ringbaPortal').component('countdown', {
    bindings: {
      expiresOn: '<',
      timeZoneId: '<',
      onExpire: '&'
    },
    controller: CountdownController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/countdown/countdown.view.html'
  });

  function CountdownController(
    _,
    $interval,
    dateTimeService,
    moment,
    timeFormatService
  ) {
    'ngInject';

    const vm = this;
    let countdownInterval;

    vm.$onChanges = onChanges;
    vm.$onDestroy = onDestroy;


    function onChanges(changesObj) {
      if (changesObj.expiresOn && vm.expiresOn) {
        _cancelInterval();
        _setCountdownDisplay(vm.expiresOn);
      }
    }

    function onDestroy() {
      _cancelInterval();
      vm.hideCountdown = true;
    }

    function _setCountdownDisplay(expiresOn) {
      vm.hideCountdown = false;
      const endMoment = moment(expiresOn);
      const currentMoment = dateTimeService.getCurrentMomentInTimeZone(vm.timeZoneId);
      if (endMoment.diff(dateTimeService.getCurrentMomentInTimeZone(vm.timeZoneId), 'days') > 0) {
        vm.expiresInDisplay = _.capitalize(moment.duration(endMoment.diff(currentMoment)).humanize() + ' left');
        _cancelInterval();
      } else if (currentMoment.isBefore(endMoment)) {
        _resetCountdown(endMoment);
      } else {
        vm.hideCountdown = true;
      }
    }

    function _resetCountdown(endMoment) {
      countdownInterval = $interval(function() {
        const duration = moment.duration(endMoment.diff(dateTimeService.getCurrentMomentInTimeZone(vm.timeZoneId)));
        if (duration.asSeconds() < 0) {
          _cancelInterval();
          vm.hideCountdown = true;
          vm.onExpire();
        } else {
          vm.expiresInDisplay = timeFormatService.secondsToDisplay(duration.asSeconds());
        }

      }, 1000);
    }

    function _cancelInterval() {
      if (countdownInterval) {
        $interval.cancel(countdownInterval);
        countdownInterval = null;
      }
    }

  }
})();
